module.exports = __webpack_public_path__ + "img/nav1_1.c31c7f8a.jpg";